<div *ngIf="!loading" @fadeInOut class="reference-detail mb-4" >
  <div class="row" *ngIf="!!reference" [sxc-toolbar]="toolbarservice.toolbarFor(reference)" >

    <div class="col-12 col-md-6 col-lg-8 d-flex flex-column" >
      <h1>{{reference.Title}}</h1>

      <div *ngIf="!!reference?.Responsible">
        <strong>Verantwortlicher</strong><br>
        <div [innerHTML]="reference?.Responsible" class="mb-3"></div>

      </div>

      <div *ngIf="!!reference?.Customer">
        <strong>Auftraggeber</strong><br>
        <div [innerHTML]="reference?.Customer" class="mb-3"></div>
      </div>


      <div *ngIf="!!reference?.Description">
        <strong>Beschreibung</strong><br>
        <div [innerHTML]="reference?.Description" class="mb-3"></div>
      </div>

      <div *ngIf="!!reference?.Links">
        <strong>{{linksLabel}}</strong><br>
        <div [innerHTML]="reference?.Links" class="mb-3"></div>
      </div>

    </div>



    <div *ngIf="images$ | async as images" @fadeInOut class="ref-images col-12 col-md-6 col-lg-4">
      <div *ngIf="images.length > 0" class="row">

      <!-- Thubmnail -->
        <div class="mb-3 col-12 col-sm-6 col-md-12">
          <img [lightbox]="0"[src]="images[0].Url + '?w=800&h=800&mode=crop&scale=both'" class="img-fluid rounded shadow">
        </div>

        <!-- bilder Galerie -->
        <div class=" col-12 col-sm-6 col-md-6 mb-3" *ngFor="let item of items | slice: 1; index as i">
          <img class="img-fluid rounded shadow" [lightbox]="i+1" [src]="item.data.thumb">
        </div>
      </div>
    </div>


    <ng-container *ngIf="!reference">
      <p>Es wurde keine Referenz mit den entsprechenden Angaben gefunden.</p>
    </ng-container>

  </div>
  <br>
  <a class="btn btn-primary" [routerLink]="['/category', 'all']"><i class="fal fa-long-arrow-left"></i> {{btnBack}}</a>
</div>
